/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import { Radio, Select } from "antd";
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getDomainBrandIdentity } from "../../../../../store/actions/domain-brand.action";
import { fetchAppLanguage } from "../../../../../utils/helpers/logicHelper";
import {
  globalFonts,
  pageLetterSpacing,
  pageTitleFont,
} from "../../../../../utils/helpers/objectHelpers";
import { fetchSubDomain } from "../../../../../utils/services/baseUrl";
import { ManagerService } from "../../../../../utils/services/manager.service";

function Fonts({ dictionary, fontStore, domainBrand }) {
  const dispatch = useDispatch();
  const subdomain = fetchSubDomain();
  const selectedLanguage = fetchAppLanguage();
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [font, setFont] = useState(false);
  const [fontsData, setFontsData] = useState({
    font_style4: domainBrand?.domainBrand?.font_style4 || "Lato",
    font_size1: domainBrand?.domainBrand?.font_size1 || "24px",
    font_style5: domainBrand?.domainBrand?.font_style5 || "24px",
    font_size2: domainBrand?.domainBrand?.font_size2 || "24px",
    font_spacing1: domainBrand?.domainBrand?.font_spacing1 || "0px",
  });

  const fontArray = fontStore?.map((i) => {
    return { label: i.family, value: i.family };
  });

  const updateBrandSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateBrandSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getDomainBrandIdentity(subdomain, selectedLanguage["id"]));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setFont(!font)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {font ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary ? dictionary["l_font_settings"] : "FONT SETTINGS"}
          </li>
          <Collapse in={font}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary["para_change_font_styles_on_the_website"]
                  : `Change font styles on the website.`}
              </h6>
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-5 mb-3">
                  <label>
                    {dictionary ? dictionary["l_global_font"] : "Global Font"}
                  </label>
                  <div>
                    <Select
                      defaultValue={fontsData?.font_style4}
                      onChange={(value) => {
                        setFontsData({ ...fontsData, font_style4: value });
                      }}
                      options={fontArray}
                      className="w-100"
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-5 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["l_global_font_size"]
                      : "Global Font Size"}
                  </label>

                  <div>
                    <Select
                      defaultValue={fontsData?.font_size1}
                      onChange={(value) => {
                        setFontsData({ ...fontsData, font_size1: value });
                      }}
                      options={globalFonts}
                      className="w-100"
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-5 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["l_page_title_font"]
                      : "Page Title Font"}
                  </label>

                  <div>
                    <Select
                      defaultValue={fontsData?.font_style5}
                      onChange={(value) => {
                        setFontsData({ ...fontsData, font_style5: value });
                      }}
                      options={fontArray}
                      className="w-100"
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-5 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["l_page_title_font_size"]
                      : "Page Title Font Size"}
                  </label>

                  <div>
                    <Select
                      defaultValue={fontsData?.font_size2}
                      onChange={(value) => {
                        setFontsData({ ...fontsData, font_size2: value });
                      }}
                      options={pageTitleFont}
                      className="w-100"
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-5 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["l_page_title_letter_spacing"]
                      : "Page Title Letter Spacing"}
                  </label>

                  <div>
                    <Select
                      defaultValue={fontsData?.font_spacing1}
                      onChange={(value) => {
                        setFontsData({ ...fontsData, font_spacing1: value });
                      }}
                      options={pageLetterSpacing}
                      className="w-100"
                    />
                  </div>
                </div>
              </div>

              {/* BUTTON */}
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 float-start mb-3">
                  <button
                    // onClick={() => updateRemittanceValue(hideObject)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {dictionary
                      ? dictionary["l_reset_settings"]
                      : "RESET SETTINGS"}
                    {/* {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )} */}
                  </button>
                </div>
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() => updateBrandSettings(fontsData)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                  >
                    {dictionary ? dictionary["b_update"] : "UPDATE"}
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default Fonts;
